import { render, staticRenderFns } from "./StepPromotersComponent.vue?vue&type=template&id=3389e4da&scoped=true"
import script from "./StepPromotersComponent.vue?vue&type=script&lang=js"
export * from "./StepPromotersComponent.vue?vue&type=script&lang=js"
import style0 from "./StepPromotersComponent.vue?vue&type=style&index=0&id=3389e4da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3389e4da",
  null
  
)

export default component.exports